import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { ConfirmModalComponent } from 'src/app/shared/components/simple/confirm-modal/confirm-modal.component';
import { notesAllowProceed } from './kyc-postpone.util';

/**
 * Open the "adopt the official SERPRO name" confirm modal. Single source of truth for the
 * CONFIRM_AUTO_ACTION popup — used by the validation resolver AND the pre-terminal guard.
 * Resolves true iff the user confirmed.
 */
export async function confirmAdoptSerproName(
  dialog: MatDialog,
  suggestedName: string,
  translate: TranslateService,
): Promise<boolean> {
  const ref = dialog.open(ConfirmModalComponent, {
    data: {
      titleIcon: 'badge',
      title: translate.instant('KycConfirmNameTitle'),
      message: suggestedName
        ? translate.instant('KycConfirmNameMessage', { name: suggestedName })
        : translate.instant('KycConfirmNameMessageNoName'),
      confirmText: translate.instant('KycConfirmNameYes'),
      cancelButton: translate.instant('KycConfirmNameNo'),
      emphasizeConfirm: true,
      disableClose: true,
    },
    width: '600px',
    maxWidth: '90vw',
  });
  return (await firstValueFrom(ref.afterClosed())) === true;
}

/**
 * After adopting the SERPRO name and revalidating, decide which terminal screen to show:
 * 'success' (Identity Verified OR postpone "under review") when the check passed or a postpone
 * note allows proceeding; otherwise 'failure'.
 */
export function decideTerminalAfterRevalidate(
  check: { passed?: boolean; notes?: any[] } | null | undefined,
): 'success' | 'failure' {
  if (!check) return 'failure';
  return check.passed === true || notesAllowProceed(check.notes) ? 'success' : 'failure';
}
